'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The child element needs to handle a property {validate} and do its
 * own validation, e.g. in onComponentDidMount.  If valid, it should call
 * the callback {onValidates}.
 */
var ModalDialog = function (_React$Component) {
	_inherits(ModalDialog, _React$Component);

	function ModalDialog(props) {
		_classCallCheck(this, ModalDialog);

		var _this = _possibleConstructorReturn(this, (ModalDialog.__proto__ || Object.getPrototypeOf(ModalDialog)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		_this.onOkayClicked = _this.onOkayClicked.bind(_this);
		_this.doValidate = _this.doValidate.bind(_this);
		_this.onValidates = _this.onValidates.bind(_this);
		_this.onClose = _this.onClose.bind(_this);
		_this.state = {
			validate: false
		};
		return _this;
	}

	_createClass(ModalDialog, [{
		key: 'onOkayClicked',
		value: function onOkayClicked() {
			var _props = this.props,
			    validateOnOkay = _props.validateOnOkay,
			    onOkay = _props.onOkay;
			// Skip validation and close

			if (!validateOnOkay && onOkay) {
				onOkay();
				// Run validation before closing
			} else if (validateOnOkay) {
				this.doValidate();
			}
		}
	}, {
		key: 'doValidate',
		value: function doValidate() {
			this.setState({
				validate: true
			});
		}
	}, {
		key: 'onValidates',
		value: function onValidates(values) {
			var _this2 = this;

			this.setState({
				validate: false
			}, function () {
				if (_this2.props.onOkay) {
					_this2.props.onOkay(values);
				}
			});
		}
	}, {
		key: 'onClose',
		value: function onClose() {
			this.setState({
				validate: false
			});
			if (this.props.onClose) {
				this.props.onClose();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props2 = this.props,
			    title = _props2.title,
			    subtitle = _props2.subtitle,
			    onClose = _props2.onClose,
			    onOkay = _props2.onOkay,
			    show = _props2.show,
			    undecorated = _props2.undecorated,
			    onExited = _props2.onExited,
			    onEnter = _props2.onEnter,
			    dialogClassName = _props2.dialogClassName,
			    backdrop = _props2.backdrop;

			var okayText = this.props.okayText || this.intl.formatMsg('Ok');
			var closeText = this.props.closeText || this.intl.formatMsg('Close');

			var children = _react2.default.Children.map(this.props.children, function (child) {
				return _react2.default.cloneElement(child, {
					onValidates: _this3.onValidates,
					validate: _this3.state.validate,
					doValidate: _this3.doValidate
				});
			});

			return _react2.default.createElement(
				_reactBootstrap.Modal,
				{
					show: show,
					onHide: this.onClose,
					onExited: onExited,
					onEnter: onEnter,
					dialogClassName: dialogClassName,
					backdrop: backdrop
				},
				!undecorated && _react2.default.createElement(
					_reactBootstrap.Modal.Header,
					{
						closeButton: true,
						className: (0, _classnames2.default)({ 'has-subtitle': subtitle })
					},
					title && _react2.default.createElement(
						_reactBootstrap.Modal.Title,
						null,
						title,
						subtitle && _react2.default.createElement(
							'div',
							{ className: 'modal-subtitle' },
							subtitle
						)
					)
				),
				_react2.default.createElement(
					_reactBootstrap.Modal.Body,
					null,
					children
				),
				!undecorated && _react2.default.createElement(
					_reactBootstrap.Modal.Footer,
					null,
					onClose && _react2.default.createElement(
						_reactBootstrap.Button,
						{
							bsSize: 'large',
							bsStyle: 'link',
							className: 'cancel',
							onClick: this.onClose
						},
						closeText
					),
					onOkay && _react2.default.createElement(
						_reactBootstrap.Button,
						{
							bsStyle: 'primary',
							bsSize: 'large',
							className: 'okay',
							onClick: this.onOkayClicked
						},
						okayText
					)
				)
			);
		}
	}]);

	return ModalDialog;
}(_react2.default.Component);

ModalDialog.propTypes = {
	/**
  * The optional title of the dialog.
  */
	title: _propTypes2.default.string,

	/**
  * Show or hide the dialog.
  */
	show: _propTypes2.default.bool,

	/**
  * Show only the content area -- no header or footer
  */
	undecorated: _propTypes2.default.bool,

	/**
  *
  */
	onClose: _propTypes2.default.func.isRequired,

	/**
  * React-Bootstrap modal callback -- fires after the modal is closed
  */
	onExited: _propTypes2.default.func,

	/**
  * React-Bootstrap modal callback -- fires after the modal is closed
  */
	onEnter: _propTypes2.default.func,

	/**
  *
  */
	onOkay: _propTypes2.default.func,

	/**
  *
  */
	closeText: _propTypes2.default.string,

	/**
  *
  */
	okayText: _propTypes2.default.string,

	/*
  * Modal will always close when OK is clicked
  */
	validateOnOkay: _propTypes2.default.bool,

	/**
  * Body
  */
	children: _propTypes2.default.any.isRequired,

	/**
  * A css class to apply to the Modal dialog DOM node
  * @type {string}
  */
	dialogClassName: _propTypes2.default.string,

	/**
  * Include a backdrop component. Specify 'static' for a backdrop that doesn't
  * trigger an "onHide" when clicked.
  *
  * That is, to have a dialog that doesn't close when the background is clicked,
  * specify 'static'.
  */
	backdrop: _propTypes2.default.oneOf(['static', true, false])
};

ModalDialog.defaultProps = {
	show: false,
	validateOnOkay: true
};

var defaultValidateTrue = function defaultValidateTrue() {
	return true;
};

function trim(string) {
	if (typeof string !== 'string') {
		return string;
	}
	return string.replace('\\t', '').trim();
}

/**
 * Assists in validating ModalDialog content.  Not strictly required for ModalDialog, but
 * can make the code cleaner.
 *
 * @example
 * class EditFoo extends ModalDialog.Content {
 *	 constructor(props) {
 *		 super(props);
 *		 this.validateName = this.validateName.bind(this);
 *		 this.onChange = this.onChange.bind(this);
 *		 // Register the field, 'name' and a validator function
 *		 this.registerFieldValidation('name', this.validateName);
 *		 this.state = {
 *		 	...this.state, // must merge parent state
 *		 	name: ''
 *		 };
 *	 }
 *	 validateName() {
 *		 return this.state.name.length > 0;
 *	 }
 *	 onChange(ev) {
 *		 // Call helper to maintain state for field value
 *		 this.setFieldState('name', ev.target.value);
 *	 }
 *	 render() {
 *		 // The `getFieldValidationProps` will set the proper bootstrap validation state.
 *		 const nameProps = this.getFieldValidationProps('name');
 *		 return (
 *			 <FormGroup controlId="nameCtrl" {...this.getFieldValidationProps('name')}>
 *				 <span className=".state">{nameProps.validationState}</span>
 *				 <FormControl
 *					  type="text"
 *					  value={this.state.name}
 *					  placeholder="Enter name"
 *					  onChange={this.onChange}
 *				 />
 *			 </FormGroup>
 *		 );
 *	 }
 * }
 *
 */

var DialogContent = function (_React$Component2) {
	_inherits(DialogContent, _React$Component2);

	function DialogContent(props) {
		_classCallCheck(this, DialogContent);

		var _this4 = _possibleConstructorReturn(this, (DialogContent.__proto__ || Object.getPrototypeOf(DialogContent)).call(this, props));

		_this4.setFieldState = _this4.setFieldState.bind(_this4);
		_this4.state = {
			__fields__: {}
		};
		return _this4;
	}

	/**
  *
  */


	_createClass(DialogContent, [{
		key: 'registerFieldValidation',
		value: function registerFieldValidation(name) {
			var validationFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultValidateTrue;

			if (!this.state.hasOwnProperty('validate')) {
				this.state.validate = this.props.validate;
			}
			if (this.state.hasOwnProperty(name)) {
				console.error('field name already registered:', name);
			}
			this.state.__fields__[name] = validationFunc;
			var prop = this.props[name];
			if (typeof prop === 'string') {
				prop = trim(prop);
			}
			this.state[name] = prop;
		}

		/**
   *
   */

	}, {
		key: 'setFieldState',
		value: function setFieldState(name, value, callback) {
			if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
				// setting as an object.
				this.setFieldStateObject(name, value);
				return;
			}
			if (!this.state.hasOwnProperty(name)) {
				console.error('unregistered field name:', name);
				return;
			}
			// update state with new value and reset validate
			var state = { validate: false };
			state[name] = value;
			this.setState(state, callback);
		}
	}, {
		key: 'setFieldStateObject',
		value: function setFieldStateObject(obj, callback) {
			// setting an object, not a string. merge all of the properties into state.
			var state = _extends({
				validate: false
			}, obj);
			this.setState(state, callback);
		}

		/**
   *
   */

	}, {
		key: 'getFieldValidationProps',
		value: function getFieldValidationProps(name) {
			var failuresOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var validate = this.state.validate;

			if (!validate) {
				return {};
			}
			var validateFunc = this.state.__fields__[name];
			if (!validateFunc) {
				console.error('unregistered validation function for field:', name);
			}
			var validates = validateFunc();
			var validateNameProps = {
				validationState: validates ? 'success' : 'error'
			};
			if (failuresOnly && validateNameProps.validationState === 'success') {
				return {};
			}
			return validateNameProps;
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(next) {
			// update state with new props
			this.setState({
				validate: next.validate
			});
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _this5 = this;

			if (!this.props.validate) {
				return;
			}
			var validates = Object.keys(this.state.__fields__).every(function (key) {
				var props = _this5.getFieldValidationProps(key, false);
				return props.validationState === 'success';
			});
			if (validates) {
				var values = Object.assign({}, this.state);
				delete values['__fields__'];
				delete values['validate'];
				// Give the validated values back to the parent so that they can use them
				this.props.onValidates(values);
			}
		}
	}]);

	return DialogContent;
}(_react2.default.Component);

DialogContent.propTypes = {
	/**
  *
  */
	validate: _propTypes2.default.bool,

	/**
  *
  */
	onValidates: _propTypes2.default.func,

	/**
  * handles validation and further actions
  */
	doValidate: _propTypes2.default.func
};

DialogContent.defaultProps = {
	validate: false
};

var injected = (0, _reactIntl.injectIntl)(ModalDialog);
injected.Content = DialogContent;

var _default = injected;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ModalDialog, 'ModalDialog', 'src/components/ModalDialog.jsx');

	__REACT_HOT_LOADER__.register(defaultValidateTrue, 'defaultValidateTrue', 'src/components/ModalDialog.jsx');

	__REACT_HOT_LOADER__.register(trim, 'trim', 'src/components/ModalDialog.jsx');

	__REACT_HOT_LOADER__.register(DialogContent, 'DialogContent', 'src/components/ModalDialog.jsx');

	__REACT_HOT_LOADER__.register(injected, 'injected', 'src/components/ModalDialog.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/ModalDialog.jsx');
}();

;